import type { KeyboardEvent as ReactKeyboardEvent, RefObject } from 'react'

import {
  Button,
  ButtonSize,
  ButtonVariant,
  Icon,
  SearchBar,
  SearchBarSize,
  SearchBarVersion,
} from '@graftcode/design-system'
import * as Dialog from '@radix-ui/react-dialog'

import { SEARCH_MODAL_TEST_IDS } from '@common/common-test-ids.const'

import type { SearchModalTab } from '../search-modal.interface'

import { SearchLineTabs } from './SearchLineTabs'

import styles from '../SearchModal.module.scss'

type SearchHeaderProps = {
  activeTabId: string
  inputRef: RefObject<HTMLInputElement | null>
  isLoading: boolean
  placeholder: string
  query: string
  tabs: readonly SearchModalTab[]
  onKeyDown?: (event: ReactKeyboardEvent<HTMLInputElement>) => void
  onQueryChange: (next: string) => void
  onTabChange: (id: string) => void
}

export function SearchHeader({
  activeTabId,
  inputRef,
  isLoading,
  placeholder,
  query,
  tabs,
  onKeyDown,
  onQueryChange,
  onTabChange,
}: SearchHeaderProps) {
  return (
    <div className={styles.stickyHead} data-testid={SEARCH_MODAL_TEST_IDS.header}>
      <div className={styles.searchRow}>
        <SearchBar
          id="search-modal-query"
          ref={inputRef}
          aria-busy={isLoading ? true : undefined}
          autoComplete="off"
          className={styles.searchInput}
          containerClassName={styles.searchBarContainer}
          name="global-search-query"
          placeholder={placeholder}
          size={SearchBarSize.SM}
          spellCheck={false}
          value={query}
          version={SearchBarVersion.Ghost}
          onChange={(e) => {
            onQueryChange(e.target.value)
          }}
          onKeyDown={onKeyDown}
        />
        <Dialog.Close asChild>
          <Button
            aria-label="Close search"
            className={styles.searchDismiss}
            icon={Icon.DismissRegular}
            iconOnly
            size={ButtonSize.M}
            type="button"
            variant={ButtonVariant.Ghost}
          />
        </Dialog.Close>
      </div>

      <SearchLineTabs activeTabId={activeTabId} tabs={tabs} onTabChange={onTabChange} />
    </div>
  )
}
